<template>
  <form class="boxForm_step5" @submit.prevent="onSubmit">
    <div class="selectPlan">
      <div class="selectPlan__header">
        <div class="selectPlan__title selectPlan__title-discount">{{$t('renew_plan_policy_price')}}
          <div class="selectPlan__wrapped-discount" v-if="schemeDiscount">
            <div class="selectPlan__wrapped-circle"></div> {{ $t('renew.label.discount')}} &lrm;-{{schemeDiscount}}%
          </div>
        </div>
      </div>

      <div class="switchQuote">
        <div class="switchQuote__container" v-for="(s, index) of schemes" :key="index">
          <input type="radio" name="policyPrice" :value="s.price" v-model="price" :id="`${index}-scheme`" >
          <label :for="`${index}-scheme`">{{ s.price | splitNumber }}</label>
        </div>
      </div>
      <div class="selectPlan__customize">
        <div class="selectPlan__customize-header">
          <div class="selectPlan__customize-title">{{$t('plan_customize_deductible')}}</div>
          <div class="selectPlan__customize-amount" v-if="deductiblePrice">{{$t('qic_qar')}} {{deductiblePrice | splitNumber}}</div>
          <div class="selectPlan__customize-amount" v-else>{{$t('qic_qar')}} 0</div>
        </div>
        <div class="selectPlan__customize-desc" >{{$t('plan_customize_deductible_desc')}}</div>
        <ul class="selectPlan__customize-list">
          <li
            v-for="(include, index) of filtredIncludedList"
            :class="include.included ? 'included' : 'not-included'"
            :key="index">
            {{include.title}}
          </li>
        </ul>
        <div class="selectPlan__price">
          <div v-if="schemeDiscount" class="selectPlan__price_old">
            <span class="selectPlan__price_old_bold">{{ $t('renew.price.qar') }}</span>&nbsp;
            <span class="selectPlan__price_old_regular">{{ $options.filters.splitNumber(currentScheme?.fullPrice) }}</span>
          </div>
          <div class="selectPlan__price_base">
            <span class="selectPlan__price_base_regular">{{ $t('renew.price.from') }}</span>&nbsp;
            <span class="selectPlan__price_base_bold">{{ $t('renew_qar', { price: $options.filters.splitNumber(currentScheme?.price) }) }}</span>
          </div>
        </div>
        <i class="selectPlan__installment">
          {{ $t('select_plan_installment', {installment: installmentPrice })}} <i @click="togglePopupMore">{{ $t('renew.learn_more')}}</i>
        </i>
        <RamadanBadge v-if="ramadanIsActive" class="selectPlan__ramadan" plan-type="od" position="start" />
      </div>
    </div>
    <BaseButton>
      {{$t('plan_customize_select', { price: $options.filters.splitNumber(currentScheme?.price) })}}
    </BaseButton>

    <BasePopupWrapper :popupBig="true" @close="togglePopupMore" v-if="showMoreInfo">
      <div class="installment-select-plan__popup">
        <h3>{{ $t('qic_installment_popup.title') }}</h3>
        <h4>{{ $t('qic_installment_popup.heading_1') }}</h4>
        <p>{{ $t('qic_installment_popup.text_1_1') }}</p>
        <h4>{{ $t('qic_installment_popup.heading_2') }}</h4>
        <p>{{ $t('qic_installment_popup.text_2_1') }}</p>
        <p>{{ $t('qic_installment_popup.text_2_2') }}</p>
        <p>{{ $t('qic_installment_popup.text_2_3') }}</p>
        <h4>{{ $t('qic_installment_popup.heading_3') }}</h4>
        <p>{{ $t('qic_installment_popup.text_3_1') }} <a href="/pdf/Motor_Terms_And_Conditions_Installment.pdf" target="_blank">{{ $t('qic_installment_popup.text_3_1_link') }}.</a></p>
        <p>{{ $t('qic_installment_popup.text_3_2') }}</p>
      </div>
      <template v-slot:button>
        <base-button symbol="no" class="btn-second btn-second_medium" @click="togglePopupMore">
          {{ $t('qic_close') }}
        </base-button>
      </template>
    </BasePopupWrapper>
  </form>
</template>

<script>
import prodCodeMap from '@/assets/maps/prodCodeMap.json'
import { BasePopupWrapper } from 'qic-components'
import RamadanBadge from '@/components/campaigns/Ramadan/ui/RamadanBadge.vue'
import { mapState } from 'vuex'

export default {
  name: 'MotorChangeSelectPlan',
  components: {
    RamadanBadge,
    BasePopupWrapper
  },
  props: {
    schemes: { type: Array, defaul: () => [] },
    productType: {},
    policyInfo: { type: Object, default: () => {} }
  },
  emit: ['submit'],
  data () {
    return {
      price: null,
      allIncludes: [],
      showMoreInfo: false
    }
  },
  computed: {
    ...mapState({
      ramadanIsActive: state => state.ramadan.ramadanIsActive
    }),
    currentScheme () {
      return this.schemes.find(s => s.price === this.price)
    },
    currentIncludedList () {
      return this.currentScheme ? this.currentScheme.included : []
    },
    filtredIncludedList () {
      const staticIncludes = this.productStaticIncludes.filter(s => !this.currentIncludedList.find(include => include.id === s.id))
      return [...staticIncludes, ...this.allIncludes.map((op) => ({
        title: op,
        included: this.currentIncludedList.some((i) => i.name === op)
      })).sort((a, b) => b.included - a.included)]
    },
    deductiblePrice () {
      return this.currentScheme?.deductible || 0
    },
    schemePrice () {
      return this.currentScheme ? this.currentScheme.fullPrice : 0
    },
    productStaticIncludes () {
      const includes = this.productInfo?.staticIncludes ? [...this.productInfo?.staticIncludes] : []
      return includes
        .map(i => {
          i.name = this.$t(i.name)
          i.description = this.$t(i.description)
          return i
        })
    },
    productInfo () {
      return prodCodeMap
        .filter(prod => prod.type === this.productType)
        .find(prod => prod.code === this.policyInfo?.prodCode)
    },
    schemeDiscount () {
      return this.currentScheme ? Number((this.currentScheme.discount * 100 / this.currentScheme.fullPrice).toFixed(0)) : 0
    },
    installmentPrice () {
      return this.currentScheme.monthlyPrice
    }
  },
  methods: {
    onSubmit () {
      this.$emit('submit', this.getSchemeInfo())
    },
    getSchemeInfo () {
      return this.schemes.find(s => s.price === this.price)
    },
    togglePopupMore () {
      this.showMoreInfo = !this.showMoreInfo
      const body = document.querySelector('body')
      const overflowHidden = 'overflow-off'
      if (this.showMoreInfo) {
        body.classList.add(overflowHidden)
      } else {
        body.classList.remove(overflowHidden)
      }
    }
  },
  beforeMount () {
    this.price = this.schemes[0].price
    this.allIncludes = [...this.schemes.reduce((acc, el) => {
      el.included.forEach((i) => acc.add(i.name))
      return acc
    }, new Set())]
  }
}
</script>

<style lang="scss">
  .selectPlan__ramadan{
    margin-block-start: 12px;
  }
  .selectPlan__discount_top0 {
    position: absolute;
    -webkit-margin-end: 12px;
    margin-inline-end: 12px;
  }
  .selectPlan__from span{
    position: relative;
    top: -2px;
  }
  .selectPlan__customize-header {
    border: none;
  }
  .selectPlan__customize-desc {
    margin-bottom: 24px;
  }
  .selectPlan__wrapped-discount {
    background-color: rgba(101, 216, 64, 1);
    color: #FFFFFF;
    border: 2px solid rgba(255, 255, 255, 1);
    box-shadow: unset;
    display: flex;
    align-items: center;
    gap: 4px;
  }
  .selectPlan__wrapped-circle {
    width: 8px;
    height: 8px;
    background-color: white;
    border-radius: 64px;
  }
  .selectPlan__title-discount {
    display: flex;
  }
</style>

<style lang="scss" scoped>
  .switchQuote {
    display: flex;
    justify-content: space-between;
    flex-wrap: nowrap;
    flex-direction: row;
    &__container {
      width: 100%;
    }
  }
</style>
